export default {
  title: 'PayPal (diretto)',
  description:
    "Collega il tuo account PayPal Business per ricevere pagamenti PayPal direttamente, alla tua tariffa. Crea un'app REST nella Dashboard sviluppatori PayPal e incolla il suo Client ID e Secret qui sotto.",
  connected_description: 'Il tuo account PayPal è connesso. I pagamenti verranno accreditati direttamente su di esso.',
  guide: {
    title: 'Come ottenere le credenziali PayPal',
    step1: 'Accedi alla Dashboard sviluppatori PayPal con il tuo account PayPal Business.',
    step2: "Apri «App e credenziali» e crea un'app (o apri quella esistente).",
    step3: "Copia il Client ID e il Secret dell'app.",
    step4: 'Incollali qui sotto e clicca su «Collega PayPal».',
    environment_note:
      'Usa le credenziali Live per i pagamenti reali — attiva il toggle Sandbox/Live in cima ad «App e credenziali».',
    open_dashboard: 'Apri la Dashboard sviluppatori PayPal',
  },
  status: {
    connected: 'Connesso',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: "Client ID dell'app REST PayPal",
    },
    client_secret: {
      label: 'Secret',
      placeholder: "Secret dell'app REST PayPal",
    },
  },
  buttons: {
    connect: 'Collega PayPal',
    disconnect: 'Disconnetti',
  },
  toasts: {
    connected: 'PayPal connesso con successo',
    connect_failed: 'Impossibile connettere PayPal',
    disconnected: 'PayPal disconnesso',
    disconnect_failed: 'Impossibile disconnettere PayPal',
  },
};
